
import React, { useState } from 'react';
import { FaShieldAlt, FaFighterJet, FaShip, FaMountain, FaUserShield, FaAward, FaMedal, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaRunning, FaGraduationCap, FaUsers, FaFlag, FaStar, FaBullseye, FaHeart, FaBrain, FaDumbbell } from 'react-icons/fa';

const DefenceSecurityPage = () => {
  const [expandedOrg, setExpandedOrg] = useState(null);
  const [expandedExam, setExpandedExam] = useState(null);

  const organizations = [
    {
      id: 'indian-army',
      name: 'Indian Army',
      fullName: 'Indian Army',
      icon: <FaShieldAlt />,
      established: '1895',
      type: 'Land Forces',
      headquarters: 'New Delhi',
      description: 'The land-based branch of the Indian Armed Forces',
      motto: 'Service Before Self',
      exams: [
        {
          name: 'NDA (National Defence Academy)',
          posts: ['Army Wing', 'Navy Wing', 'Air Force Wing'],
          eligibility: '12th Pass (PCM for Air Force & Navy, Any stream for Army)',
          ageLimit: '16.5 - 19.5 years',
          salary: '₹56,100 - ₹1,77,500/month (after commissioning)',
          grade: 'Lieutenant to Field Marshal',
          examPattern: [
            { phase: 'Written Exam - Mathematics', duration: '150 minutes', sections: 'Algebra, Trigonometry, Calculus, Geometry, Statistics', total: '300 marks' },
            { phase: 'Written Exam - GAT', duration: '150 minutes', sections: 'English, Physics, Chemistry, GK, History, Geography, Current Affairs', total: '600 marks' },
            { phase: 'SSB Interview', duration: '5 days', sections: 'Psychological Tests, GTO, Interview, Conference', total: '900 marks' },
            { phase: 'Medical Examination', duration: '3-4 days', sections: 'Physical & Medical Standards', total: 'Qualifying' }
          ],
          syllabus: {
            mathematics: ['Algebra', 'Matrices', 'Trigonometry', 'Analytical Geometry', 'Differential Calculus', 'Integral Calculus', 'Vector Algebra', 'Statistics', 'Probability'],
            generalAptitude: ['English Grammar', 'Comprehension', 'Physics', 'Chemistry', 'General Science', 'History', 'Geography', 'Current Affairs', 'General Knowledge'],
            ssbTests: ['OIR Test', 'PP&DT', 'TAT', 'WAT', 'SRT', 'GTO Tasks', 'Personal Interview', 'Conference']
          },
          training: {
            duration: '3 years at NDA + 1 year at IMA/INA/AFA',
            location: 'NDA Khadakwasla, Pune',
            allowance: '₹21,000/month during training',
            facilities: ['World-class infrastructure', 'Sports facilities', 'Academic excellence', 'Military training', 'Leadership development']
          },
          responsibilities: ['Leading troops in combat', 'Territorial defence', 'Counter-insurgency operations', 'Disaster relief', 'Nation building', 'Internal security'],
          careerPath: 'Navik → Leading Navik → Pradhan Adhikari → Adhikari → Warrant Officer',
        },
        {
          name: 'Coast Guard Yantrik',
          posts: ['Yantrik (Engineering)'],
          eligibility: '10+2 with Maths, Physics, Chemistry (60%)',
          ageLimit: '18-22 years',
          salary: '₹29,200 - ₹92,300/month',
          grade: 'Yantrik',
          examPattern: [
            { phase: 'Written Exam', duration: '90 minutes', sections: 'Mathematics, Physics, Chemistry, Reasoning, English', total: '200 marks' },
            { phase: 'Physical Fitness Test', duration: 'Varies', sections: '1.6 km run, Squats, Push-ups', total: 'Qualifying' },
            { phase: 'Medical', duration: '2 days', sections: 'Physical Standards', total: 'Qualifying' }
          ],
          training: {
            duration: '52 weeks',
            location: 'Coast Guard Training Centers',
            subjects: ['Marine Engineering', 'Electrical Systems', 'Diesel Engines', 'Hydraulics']
          },
          responsibilities: ['Engine room operations', 'Technical maintenance', 'Equipment repair', 'System monitoring'],
          careerPath: 'Yantrik → Senior Yantrik → Chief Yantrik → Warrant Officer'
        }
      ],
      benefits: ['Sea going allowance', 'Flying allowance', 'Hard area allowance', 'Free medical', 'CSD facilities', 'Adventure sports', 'Overseas deployment']
    }
  ];

  const ssbPreparation = {
    title: 'SSB Interview - 5 Day Process',
    days: [
      {
        day: 'Day 1',
        tests: ['Screening Test (OIR + PPDT)', 'Stage I'],
        description: 'Officer Intelligence Rating test (50 questions in 30 min) and Picture Perception & Description Test',
        result: 'Conference - Screened Out/Screened In'
      },
      {
        day: 'Day 2',
        tests: ['Psychological Tests - TAT, WAT, SRT, SD'],
        description: 'Thematic Apperception Test (12 pictures), Word Association Test (60 words in 15 sec each), Situation Reaction Test (60 situations), Self Description (5 parts)',
        tips: ['Be spontaneous', 'Show positive attitude', 'Military qualities']
      },
      {
        day: 'Day 3 & 4',
        tests: ['Group Testing Officer (GTO) Tasks'],
        description: 'GD, GPE, HGT, Individual Obstacles, Command Task, FGT, Progressive Group Task, Lecturette',
        tips: ['Show leadership', 'Team player', 'Problem solving', 'Physical fitness']
      },
      {
        day: 'Day 5',
        tests: ['Personal Interview & Conference'],
        description: 'In-depth interview with Interviewing Officer (IO) covering education, family, hobbies, current affairs, motivation. Final conference with all assessors.',
        tips: ['Be honest', 'Know yourself', 'Current affairs', 'Clear thoughts']
      }
    ],
    ofqRequired: [
      'Effective Intelligence',
      'Power of Expression',
      'Reasoning Ability',
      'Organizing Ability',
      'Social Adaptability',
      'Cooperation',
      'Sense of Responsibility',
      'Initiative',
      'Self Confidence',
      'Speed of Decision',
      'Courage',
      'Determination',
      'Stamina',
      'Group Influencing Ability',
      'Liveliness'
    ]
  };

  const physicalStandards = {
    army: {
      height: { male: '157 cm', female: '152 cm' },
      chest: { male: '77-82 cm (5 cm expansion)', female: 'N/A' },
      weight: { male: '50 kg', female: '48 kg' },
      vision: { male: '6/6, 6/6 (correctable to 6/6)', female: '6/6, 6/6' }
    },
    navy: {
      height: { male: '157 cm', female: '152 cm' },
      chest: { male: '77-82 cm (5 cm expansion)', female: 'N/A' },
      weight: { male: 'Proportionate', female: 'Proportionate' },
      vision: { male: '6/6, 6/9 (correctable to 6/6)', female: '6/6, 6/6' }
    },
    airForce: {
      height: { male: '162.5 cm', female: '152 cm' },
      legLength: { male: 'Min: 99 cm, Max: 120 cm', female: 'N/A' },
      thighLength: { male: 'Max: 64 cm', female: 'N/A' },
      vision: { male: '6/6, 6/6 (no correction for Flying)', female: '6/6, 6/6' }
    },
    capf: {
      height: { male: '165 cm', female: '157 cm' },
      chest: { male: '80-85 cm (5 cm expansion)', female: 'N/A' },
      weight: { male: 'Proportionate', female: '48 kg minimum' },
      vision: { male: '6/6, 6/9 (without correction)', female: '6/6, 6/9' }
    }
  };

  const comparativeAnalysis = [
    {
      exam: 'NDA',
      eligibility: '12th Pass',
      ageLimit: '16.5-19.5 yrs',
      salary: '₹56,100 - ₹1,77,500',
      prestige: 'Highest',
      difficulty: 'Very High',
      training: '4 years',
      type: 'Tri-Services'
    },
    {
      exam: 'CDS',
      eligibility: 'Graduate',
      ageLimit: '19-24 yrs',
      salary: '₹56,100 - ₹1,77,500',
      prestige: 'Very High',
      difficulty: 'High',
      training: '1-2 years',
      type: 'Tri-Services'
    },
    {
      exam: 'AFCAT',
      eligibility: 'Graduate',
      ageLimit: '20-24 yrs',
      salary: '₹56,100 - ₹1,77,500',
      prestige: 'Very High',
      difficulty: 'High',
      training: '74 weeks',
      type: 'Air Force Only'
    },
    {
      exam: 'CAPF AC',
      eligibility: 'Graduate',
      ageLimit: '20-25 yrs',
      salary: '₹56,100 - ₹1,77,500',
      prestige: 'High',
      difficulty: 'Moderate-High',
      training: '1 year',
      type: 'Paramilitary'
    },
    {
      exam: 'Coast Guard AC',
      eligibility: 'Graduate',
      ageLimit: '21-25 yrs',
      salary: '₹56,100 - ₹1,77,500',
      prestige: 'High',
      difficulty: 'Moderate-High',
      training: '1 year',
      type: 'Coast Guard'
    },
    {
      exam: 'Navy SSR',
      eligibility: '10+2 PCM',
      ageLimit: '17-20 yrs',
      salary: '₹26,900 - ₹69,500',
      prestige: 'Good',
      difficulty: 'Moderate',
      training: '24 weeks',
      type: 'Sailor Entry'
    },
    {
      exam: 'IAF Airmen',
      eligibility: '10+2 PCM',
      ageLimit: '17-21 yrs',
      salary: '₹26,900 - ₹69,100',
      prestige: 'Good',
      difficulty: 'Moderate',
      training: '74 weeks',
      type: 'Airmen Entry'
    }
  ];

  const preparationRoadmap = [
    {
      phase: 'Foundation Phase (3-4 months)',
      focus: 'Building strong fundamentals',
      activities: [
        'Complete syllabus understanding',
        'Mathematics concept clarity (NDA/CDS)',
        'English grammar & vocabulary',
        'General awareness - daily newspaper reading',
        'Start physical fitness routine',
        'Learn about armed forces structure'
      ]
    },
    {
      phase: 'Intensive Practice (4-5 months)',
      focus: 'Speed, accuracy & endurance',
      activities: [
        'Topic-wise practice tests',
        'Previous year question papers (10 years)',
        'Time-bound practice',
        'Current affairs compilation',
        'Physical fitness - running, push-ups, sit-ups',
        'Defence current affairs focus'
      ]
    },
    {
      phase: 'SSB Preparation (2-3 months)',
      focus: 'Personality development & OLQs',
      activities: [
        'Psychology tests practice',
        'Group discussion participation',
        'Public speaking & lecturette',
        'Self-awareness exercises',
        'Current affairs & general knowledge',
        'Mock SSB interviews'
      ]
    },
    {
      phase: 'Final Preparation (1-2 months)',
      focus: 'Consolidation & confidence',
      activities: [
        'Full-length mock tests',
        'Revision of important topics',
        'Physical fitness peak',
        'Medical fitness check',
        'Interview preparation',
        'Positive mindset development'
      ]
    }
  ];

  const careerBenefits = [
    'Serve the nation with pride and honor',
    'Excellent salary with multiple allowances',
    'Free medical facilities for self and family',
    'Subsidized canteen facilities (CSD)',
    'Government accommodation or HRA',
    'Children education allowance',
    'Leave Travel Concession (LTC)',
    'Generous pension and gratuity',
    'Adventure sports opportunities',
    'International exposure and training',
    'Leadership development',
    'Physical fitness and discipline',
    'Job security and stability',
    'Social respect and prestige',
    'Post-retirement opportunities',
    'Commonwealth & foreign training'
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'Expert Faculty',
      description: 'Learn from ex-defence personnel and experienced trainers'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Test Series',
      description: 'Comprehensive mock tests for NDA, CDS, AFCAT, CAPF'
    },
    {
      icon: <FaDumbbell />,
      title: 'Physical Training',
      description: 'Structured PT program for fitness tests and stamina'
    },
    {
      icon: <FaBrain />,
      title: 'SSB Interview Prep',
      description: 'Complete SSB training with psychology tests and GTO tasks'
    },
    {
      icon: <FaUsers />,
      title: 'Group Discussions',
      description: 'Regular GD practice for personality development'
    },
    {
      icon: <FaTrophy />,
      title: 'Success Track Record',
      description: 'Proven results with hundreds of successful candidates'
    }
  ];

  const toggleOrg = (id) => {
    setExpandedOrg(expandedOrg === id ? null : id);
  };

  const toggleExam = (id) => {
    setExpandedExam(expandedExam === id ? null : id);
  };

  return (
    <div className="min-vh-100 " style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #1a472a 0%, #2d5f3f 50%, #1a472a 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">Defence & Security Sector</h1>
              <p className="lead mb-4">
                Join the Indian Armed Forces and Paramilitary Forces. Comprehensive training for NDA, CDS, AFCAT, CAPF, Coast Guard, and SSB Interview preparation. Serve the nation with pride and honor.
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Start Your Journey</button>
              <button className="btn btn-outline-light btn-lg px-4">Book Free Counselling</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaShieldAlt size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-success fw-bold mb-1">50,000+</h3>
              <p className="text-muted mb-0">Annual Vacancies</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-danger fw-bold mb-1">₹21K-2L</h3>
              <p className="text-muted mb-0">Salary Range/Month</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-info fw-bold mb-1">15+ Forces</h3>
              <p className="text-muted mb-0">Defence Organizations</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-warning fw-bold mb-1">12th/Graduate</h3>
              <p className="text-muted mb-0">Eligibility</p>
            </div>
          </div>
        </div>
      </div>

      {/* Defence Forces & Exams */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Defence Forces & Their Examinations</h2>
        <div className="row">
          <div className="col-10 mx-auto">
            {organizations.map((org) => (
              <div key={org.id} className="card mb-3 border-0 shadow-sm">
                <div 
                  className="card-header d-flex justify-content-between align-items-center"
                  onClick={() => toggleOrg(org.id)}
                  style={{ cursor: 'pointer', background: 'linear-gradient(135deg, #1a472a 0%, #2d5f3f 100%)', color: 'white' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="me-3" style={{ fontSize: '2rem' }}>
                      {org.icon}
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold">{org.name}</h5>
                      <small>{org.fullName} • Est: {org.established} • {org.motto}</small>
                    </div>
                  </div>
                  {expandedOrg === org.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {expandedOrg === org.id && (
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <p className="mb-2"><strong>Type:</strong> {org.type}</p>
                        <p className="mb-2"><strong>Headquarters:</strong> {org.headquarters}</p>
                        <p className="mb-2"><strong>Description:</strong> {org.description}</p>
                      </div>
                      <div className="col-md-6">
                        {org.forces && (
                          <div>
                            <p className="mb-2"><strong>Forces Under CAPF:</strong></p>
                            <div className="d-flex flex-wrap gap-2">
                              {org.forces.map((force, idx) => (
                                <span key={idx} className="badge bg-success">{force}</span>
                              ))}
                            </div>
                          </div>
                        )}
                        {org.ranks && (
                          <div className="mt-3">
                            <p className="mb-2"><strong>Ranks:</strong></p>
                            <small className="text-muted">{org.ranks.join(' → ')}</small>
                          </div>
                        )}
                      </div>
                    </div>

                    {org.forces_detail && (
                      <div className="mb-4">
                        <h6 className="fw-bold mb-3">Forces Overview:</h6>
                        <div className="row g-3">
                          {org.forces_detail.map((force, idx) => (
                            <div key={idx} className="col-md-6">
                              <div className="card border-success">
                                <div className="card-body p-3">
                                  <h6 className="text-success fw-bold">{force.name}</h6>
                                  <p className="small mb-1"><strong>Role:</strong> {force.role}</p>
                                  <p className="small mb-0"><strong>Strength:</strong> {force.strength}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <h6 className="fw-bold mb-3">Examinations & Entry Schemes:</h6>
                    {org.exams.map((exam, idx) => (
                      <div key={idx} className="card mb-3 border-light">
                        <div 
                          className="card-header bg-light d-flex justify-content-between align-items-center"
                          onClick={() => toggleExam(`${org.id}-${idx}`)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div>
                            <h6 className="text-success fw-bold mb-1">{exam.name}</h6>
                            <small className="text-muted">Salary: {exam.salary} | Age: {exam.ageLimit}</small>
                          </div>
                          {expandedExam === `${org.id}-${idx}` ? <FaChevronUp /> : <FaChevronDown />}
                        </div>
                        {expandedExam === `${org.id}-${idx}` && (
                          <div className="card-body">
                            <div className="row mb-4">
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Eligibility:</strong></p>
                                <p className="small text-muted">{exam.eligibility}</p>
                              </div>
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Age Limit:</strong></p>
                                <p className="small text-muted">{exam.ageLimit}</p>
                              </div>
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Salary:</strong></p>
                                <p className="small text-success fw-bold">{exam.salary}</p>
                              </div>
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Grade:</strong></p>
                                <p className="small text-info">{exam.grade}</p>
                              </div>
                            </div>

                            {exam.posts && (
                              <div className="mb-4">
                                <h6 className="fw-bold mb-2">Available Posts/Branches:</h6>
                                <div className="d-flex flex-wrap gap-2">
                                  {exam.posts.map((post, pIdx) => (
                                    <span key={pIdx} className="badge bg-info">{post}</span>
                                  ))}
                                </div>
                              </div>
                            )}

                            {exam.trades && (
                              <div className="mb-4">
                                <h6 className="fw-bold mb-2">Available Trades:</h6>
                                <div className="d-flex flex-wrap gap-2">
                                  {exam.trades.map((trade, tIdx) => (
                                    <span key={tIdx} className="badge bg-secondary">{trade}</span>
                                  ))}
                                </div>
                              </div>
                            )}

                            <h6 className="fw-bold mb-3">Examination Pattern:</h6>
                            <div className="table-responsive">
                              <table className="table table-sm table-bordered">
                                <thead className="table-success">
                                  <tr>
                                    <th>Phase</th>
                                    <th>Duration</th>
                                    <th>Sections</th>
                                    <th>Total Marks</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {exam.examPattern.map((pattern, pIdx) => (
                                    <tr key={pIdx}>
                                      <td className="fw-semibold">{pattern.phase}</td>
                                      <td>{pattern.duration}</td>
                                      <td><small>{pattern.sections}</small></td>
                                      <td className="text-success">{pattern.total}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            {exam.syllabus && (
                              <div className="mb-4">
                                <h6 className="fw-bold mb-3">Syllabus Highlights:</h6>
                                <div className="row">
                                  {Object.entries(exam.syllabus).map(([key, topics], sIdx) => (
                                    <div key={sIdx} className="col-md-6 mb-3">
                                      <div className="card border-0 bg-light">
                                        <div className="card-body p-3">
                                          <h6 className="text-success mb-2">{key.replace(/([A-Z])/g, ' $1').trim().toUpperCase()}</h6>
                                          <div className="d-flex flex-wrap gap-1">
                                            {Array.isArray(topics) ? topics.map((topic, tIdx) => (
                                              <span key={tIdx} className="badge bg-secondary small">{topic}</span>
                                            )) : <p className="small mb-0">{topics}</p>}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {exam.training && (
                              <div className="alert alert-success mb-4">
                                <h6 className="fw-bold mb-2">Training Details:</h6>
                                <p className="mb-1"><strong>Duration:</strong> {exam.training.duration}</p>
                                <p className="mb-1"><strong>Location:</strong> {exam.training.location}</p>
                                <p className="mb-1"><strong>Allowance:</strong> {exam.training.allowance}</p>
                                {exam.training.subjects && (
                                  <p className="mb-1"><strong>Subjects:</strong> {exam.training.subjects.join(', ')}</p>
                                )}
                                {exam.training.branches && (
                                  <p className="mb-1"><strong>Branches:</strong> {exam.training.branches.join(', ')}</p>
                                )}
                                {exam.training.facilities && (
                                  <div>
                                    <strong>Facilities:</strong>
                                    <ul className="mb-0 mt-1">
                                      {exam.training.facilities.map((facility, fIdx) => (
                                        <li key={fIdx}><small>{facility}</small></li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            )}

                            <div className="mb-3">
                              <h6 className="fw-bold mb-2">Key Responsibilities:</h6>
                              <div className="row">
                                {exam.responsibilities.map((resp, rIdx) => (
                                  <div key={rIdx} className="col-md-6 mb-2">
                                    <FaCheckCircle className="text-success me-2" size={12} />
                                    <small>{resp}</small>
                                  </div>
                                ))}
                              </div>
                            </div>

                            <div className="alert alert-info mb-0">
                              <strong>Career Path:</strong> {exam.careerPath}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    {org.benefits && (
                      <div className="mt-4">
                        <h6 className="fw-bold mb-2">Benefits & Perks:</h6>
                        <div className="row">
                          {org.benefits.map((benefit, bIdx) => (
                            <div key={bIdx} className="col-md-6 mb-2">
                              <FaCheckCircle className="text-success me-2" size={12} />
                              <small>{benefit}</small>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* SSB Interview Process */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">SSB Interview - Complete 5 Day Process</h2>
          <div className="row g-4 col-10 mx-auto mb-5">
            {ssbPreparation.days.map((day, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow h-100">
                  <div className="card-header text-white" style={{ background: 'linear-gradient(135deg, #1a472a 0%, #2d5f3f 100%)' }}>
                    <h5 className="mb-1 fw-bold">{day.day}</h5>
                    <small>{day.tests.join(' | ')}</small>
                  </div>
                  <div className="card-body">
                    <p className="mb-3">{day.description}</p>
                    {day.tips && (
                      <div>
                        <h6 className="fw-bold mb-2">Key Tips:</h6>
                        <ul className="list-unstyled">
                          {day.tips.map((tip, tIdx) => (
                            <li key={tIdx} className="mb-2">
                              <FaStar className="text-warning me-2" size={12} />
                              <small>{tip}</small>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {day.result && (
                      <div className="alert alert-warning mb-0">
                        <strong>Result:</strong> {day.result}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="card border-success col-10 mx-auto">
            <div className="card-header bg-success text-white">
              <h5 className="mb-0">Officer Like Qualities (OLQs) - 15 Required Traits</h5>
            </div>
            <div className="card-body">
              <div className="row">
                {ssbPreparation.ofqRequired.map((quality, idx) => (
                  <div key={idx} className="col-md-3 mb-2">
                    <FaMedal className="text-success me-2" />
                    <small className="fw-semibold">{quality}</small>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Physical Standards */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Physical & Medical Standards</h2>
        <div className="row g-4">
          {Object.entries(physicalStandards).map(([force, standards]) => (
            <div key={force} className="col-md-6">
              <div className="card border-0 shadow h-100">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0 text-capitalize">{force === 'airForce' ? 'Air Force' : force}</h5>
                </div>
                <div className="card-body">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Parameter</th>
                        <th>Male</th>
                        <th>Female</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(standards).map(([param, values]) => (
                        <tr key={param}>
                          <td className="text-capitalize fw-semibold">{param.replace(/([A-Z])/g, ' $1')}</td>
                          <td>{values.male}</td>
                          <td>{values.female}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Comparative Analysis */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Exam Comparison Matrix</h2>
          <div className="table-responsive">
            <table className="table table-hover bg-white">
              <thead className="table-success">
                <tr>
                  <th>Exam</th>
                  <th>Eligibility</th>
                  <th>Age Limit</th>
                  <th>Salary</th>
                  <th>Prestige</th>
                  <th>Difficulty</th>
                  <th>Training</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                {comparativeAnalysis.map((exam, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold">{exam.exam}</td>
                    <td>{exam.eligibility}</td>
                    <td>{exam.ageLimit}</td>
                    <td className="text-success">{exam.salary}</td>
                    <td>
                      <span className={`badge ${
                        exam.prestige === 'Highest' ? 'bg-danger' :
                        exam.prestige === 'Very High' ? 'bg-warning' :
                        exam.prestige === 'High' ? 'bg-info' : 'bg-primary'
                      }`}>{exam.prestige}</span>
                    </td>
                    <td>{exam.difficulty}</td>
                    <td>{exam.training}</td>
                    <td><span className="badge bg-success">{exam.type}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Preparation Roadmap */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">12-Month Preparation Roadmap</h2>
        <div className="row g-4">
          {preparationRoadmap.map((phase, idx) => (
            <div key={idx} className="col-md-3">
              <div className="card border-0 shadow h-100">
                <div className="card-header bg-gradient text-dark" style={{ background: `linear-gradient(135deg, ${['#1a472a', '#2d5f3f', '#3d6f4f', '#4d7f5f'][idx]} 0%, ${['#0d3316', '#1a472a', '#2d5f3f', '#3d6f4f'][idx]} 100%)` }}>
                  <h5 className="mb-1 fw-bold">{phase.phase}</h5>
                  <small>Focus: {phase.focus}</small>
                </div>
                <div className="card-body">
                  <h6 className="fw-bold mb-3">Key Activities:</h6>
                  <ul className="list-unstyled">
                    {phase.activities.map((activity, aIdx) => (
                      <li key={aIdx} className="mb-2">
                        <FaCheckCircle className="text-success me-2" />
                        {activity}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Career Benefits */}
      <div className="bg-white py-5">
        <div className="container col-9 mx-auto">
          <h2 className="text-center mb-5 fw-bold">Why Choose a Career in Defence & Security?</h2>
          <div className="row g-3">
            {careerBenefits.map((benefit, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body d-flex align-items-center p-3">
                    <FaCheckCircle className="text-success me-3 flex-shrink-0" size={20} />
                    <p className="mb-0">{benefit}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Subject-wise Preparation */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Subject-wise Preparation Strategy</h2>
        <div className="row g-4 col-10 mx-auto">
          <div className="col-md-6">
            <div className="card border-success h-100">
              <div className="card-header bg-success text-white">
                <h5 className="mb-0">Mathematics (NDA/CDS)</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Algebra & Trigonometry:</strong> Master formulas and shortcuts for quick calculation
                  </li>
                  <li className="mb-3">
                    <strong>Calculus:</strong> Focus on differentiation and integration problems
                  </li>
                  <li className="mb-3">
                    <strong>Geometry:</strong> Practice mensuration and coordinate geometry
                  </li>
                  <li className="mb-3">
                    <strong>Statistics:</strong> Understand mean, median, mode, and probability
                  </li>
                  <li className="mb-3">
                    <strong>Practice:</strong> Solve 50+ questions daily with time limit
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-primary h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">General Awareness</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Current Affairs:</strong> Read newspapers daily (The Hindu/Indian Express)
                  </li>
                  <li className="mb-3">
                    <strong>Defence News:</strong> Follow Ministry of Defence updates and military operations
                  </li>
                  <li className="mb-3">
                    <strong>History & Geography:</strong> Focus on Indian freedom struggle and world geography
                  </li>
                  <li className="mb-3">
                    <strong>Science:</strong> Physics, Chemistry, Biology basics from NCERT
                  </li>
                  <li className="mb-3">
                    <strong>Polity & Economy:</strong> Constitution, government schemes, economic indicators
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-info h-100">
              <div className="card-header bg-info text-white">
                <h5 className="mb-0">English Language</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Grammar:</strong> Master tenses, voices, narration, prepositions
                  </li>
                  <li className="mb-3">
                    <strong>Vocabulary:</strong> Learn 20 new words daily with usage
                  </li>
                  <li className="mb-3">
                    <strong>Comprehension:</strong> Practice reading passages and answering questions
                  </li>
                  <li className="mb-3">
                    <strong>Essay Writing:</strong> Practice essays on current topics (CDS Paper II)
                  </li>
                  <li className="mb-3">
                    <strong>Error Detection:</strong> Practice spotting grammatical errors
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-danger h-100">
              <div className="card-header bg-danger text-white">
                <h5 className="mb-0">Physical Fitness</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Running:</strong> Build stamina - 1.6 km in under 6 minutes for IAF
                  </li>
                  <li className="mb-3">
                    <strong>Push-ups:</strong> Target 20+ push-ups in one go
                  </li>
                  <li className="mb-3">
                    <strong>Sit-ups:</strong> Practice 20+ sit-ups continuously
                  </li>
                  <li className="mb-3">
                    <strong>Pull-ups:</strong> Work towards 10+ chin-ups
                  </li>
                  <li className="mb-3">
                    <strong>Overall Fitness:</strong> Swimming, rope climbing, outdoor activities
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Choose Our Training?</h2>
          <div className="row g-4">
            {features.map((feature, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="text-success mb-3" style={{ fontSize: '3rem' }}>
                    {feature.icon}
                  </div>
                  <h5 className="fw-bold mb-3">{feature.title}</h5>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Success Tips */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Success Mantras for Defence Exams</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">1</h3>
              </div>
              <h5 className="fw-bold mb-3">Discipline & Dedication</h5>
              <p className="text-muted">Follow a strict study schedule and physical training routine daily.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">2</h3>
              </div>
              <h5 className="fw-bold mb-3">Physical Fitness First</h5>
              <p className="text-muted">Start PT training from day one. No shortcuts to fitness.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">3</h3>
              </div>
              <h5 className="fw-bold mb-3">SSB Personality</h5>
              <p className="text-muted">Develop leadership qualities and stay aware of current affairs.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-info text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">4</h3>
              </div>
              <h5 className="fw-bold mb-3">Mock Tests</h5>
              <p className="text-muted">Take minimum 100+ mock tests before the actual exam.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-warning text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">5</h3>
              </div>
              <h5 className="fw-bold mb-3">Never Give Up</h5>
              <p className="text-muted">SSB rejection is common. Learn and reappear with confidence.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-dark text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">6</h3>
              </div>
              <h5 className="fw-bold mb-3">Medical Fitness</h5>
              <p className="text-muted">Maintain healthy lifestyle. Medical rejection is non-negotiable.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Important Dates & Notifications */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Upcoming Exams & Notifications</h2>
          <div className="row g-4">
            <div className="col-md-6">
              <div className="card border-success h-100">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">Twice a Year</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <FaFlag className="text-success me-2" />
                      <strong>NDA Exam:</strong> Usually in April & September
                    </li>
                    <li className="mb-3">
                      <FaFlag className="text-success me-2" />
                      <strong>CDS Exam:</strong> Usually in February & September
                    </li>
                    <li className="mb-3">
                      <FaFlag className="text-success me-2" />
                      <strong>AFCAT:</strong> Usually in February & August
                    </li>
                    <li className="mb-3">
                      <FaFlag className="text-success me-2" />
                      <strong>CAPF AC:</strong> Usually conducted once a year by UPSC
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card border-info h-100">
                <div className="card-header bg-info text-white">
                  <h5 className="mb-0">Continuous Recruitment</h5>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <FaFlag className="text-info me-2" />
                      <strong>Indian Navy SSR/AA:</strong> Twice yearly recruitment
                    </li>
                    <li className="mb-3">
                      <FaFlag className="text-info me-2" />
                      <strong>IAF Airmen:</strong> Twice yearly intake (X & Y Group)
                    </li>
                    <li className="mb-3">
                      <FaFlag className="text-info me-2" />
                      <strong>Coast Guard:</strong> Multiple recruitment drives yearly
                    </li>
                    <li className="mb-3">
                      <FaFlag className="text-info me-2" />
                      <strong>CAPF Constable:</strong> Various forces recruit throughout the year
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="alert alert-warning mt-4">
            <strong>Note:</strong> Always check official websites (upsc.gov.in, joinindianarmy.nic.in, joinindiannavy.gov.in, careerindianairforce.cdac.in) for exact dates and notifications.
          </div>
        </div>
      </div>

      {/* Medical Standards Note */}
      <div className="container py-5">
        <div className="card border-danger">
          <div className="card-header bg-danger text-white">
            <h5 className="mb-0"><FaHeart className="me-2" />Important Medical Standards Note</h5>
          </div>
          <div className="card-body">
            <h6 className="fw-bold mb-3">Common Medical Disqualifications:</h6>
            <div className="row">
              <div className="col-md-6">
                <ul>
                  <li className="mb-2">Vision below required standards (uncorrectable)</li>
                  <li className="mb-2">Color blindness (for certain branches)</li>
                  <li className="mb-2">Dental issues (cavities, improper bite)</li>
                  <li className="mb-2">Overweight/Underweight beyond limits</li>
                  <li className="mb-2">Flat feet or knock knees</li>
                  <li className="mb-2">Hearing impairment</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul>
                  <li className="mb-2">Chest expansion less than required</li>
                  <li className="mb-2">Varicose veins or hydrocele</li>
                  <li className="mb-2">Skin diseases (psoriasis, vitiligo)</li>
                  <li className="mb-2">Any surgery scars on abdomen/chest</li>
                  <li className="mb-2">Hernia or hemorrhoids</li>
                  <li className="mb-2">Heart conditions or BP issues</li>
                </ul>
              </div>
            </div>
            <div className="alert alert-warning mb-0 mt-3">
              <strong>Recommendation:</strong> Get a complete medical checkup before starting preparation. Some issues can be corrected early if identified.
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-5">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #1a472a 0%, #2d5f3f 50%, #1a472a 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Serve the Nation?</h2>
            <p className="lead mb-4">
              Join the Indian Armed Forces and Paramilitary Forces. Start your preparation today with expert guidance, comprehensive study material, physical training, and SSB interview coaching.
            </p>
            <div className="mb-4">
              <FaShieldAlt size={80} className="opacity-75" />
            </div>
            <button className="btn btn-light btn-lg px-5 me-3">Enroll Now</button>
            <button className="btn btn-outline-light btn-lg px-5">Book Free Demo Class</button>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <div className="container py-4">
        <div className="text-center text-muted">
          <small>
            All information is indicative and subject to change. Please verify from official defence recruitment websites before making decisions. Medical fitness is mandatory and non-negotiable for all defence services.
          </small>
        </div>
      </div>
    </div>
  );
};

export default DefenceSecurityPage;